
<div 
	class="selector-card"
	:class="{ 
		'selector-card--selected': modelValue,
		'selector-card--disabled': disabled
	}"
	role="button"
	:tabindex="disabled ? -1 : 0"
	:aria-pressed="modelValue"
	:aria-disabled="disabled"
	:aria-describedby="description ? `${sanitizedId}-desc` : undefined"
	@click="handleClick"
	@keydown.enter="handleClick"
	@keydown.space.prevent="handleClick"
>
	<div class="selector-card__content">
		<div class="selector-card__icon">
			<slot v-if="$slots.icon" name="icon">
			</slot>
		</div>
		<div class="selector-card__text">
			<h3 class="selector-card__title">
				<slot name="title">{{ title }}</slot>
			</h3>
			<p 
				v-if="description" 
				class="selector-card__description"
				:id="`${sanitizedId}-desc`"
			>
				{{ description }}
			</p>
		</div>
	</div>
	<div class="selector-card__check" role="img" :aria-label="modelValue ? 'Selected' : 'Not selected'">
		<v-icon 
			v-if="modelValue" 
			color="primary" 
			size="28"
			aria-hidden="true"
		>
			mdi-check
		</v-icon>
		<!-- Screen reader text for state -->
		<span class="sr-only">{{ modelValue ? 'Selected' : 'Not selected' }}</span>
	</div>
</div>
